export class OrderBoxItemModel {
    id: number;
    orderItemId: number;
    orderBoxId: number;
    orderId: number;
    quantity: number;
    weight?: number;
    productSku?: string;
    assignedQuantity: number;
}
